import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "locale-select d-flex align-items-center position-absolute top-0 ps-md-5 pb-1" }
const _hoisted_2 = { class: "dropdown p-0 p-md-2" }
const _hoisted_3 = {
  class: "btn btn-light dropdown-toggle d-flex align-items-center gap-2",
  type: "button",
  id: "languageDropdown",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "d-none d-md-block" }
const _hoisted_6 = {
  class: "dropdown-menu",
  "aria-labelledby": "languageDropdown"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]

import { ref, computed } from 'vue'

  // Types
  import { CompanyLang, Locale } from '@/types'

  // Config
  import { CookieName } from '@/config/cookies'

  // Libs
  import Cookies from 'js-cookie'
  import { useI18n } from 'vue-i18n'

  // Assets
  import NlFlag from '@/assets/nl-flag.png'
  import FrFlag from '@/assets/fr-flag.png'

  // Types
  type LocaleOption = {
    code: Locale
    name: string
    flag: string
  }

  // I18n
  
export default /*@__PURE__*/_defineComponent({
  __name: 'LocaleSelector',
  setup(__props) {

  // Vue
  const { locale, t } = useI18n()

  // Locale Data
  const locales: LocaleOption[] = [
    {
      code: 'fr-FR',
      name: 'Français',
      flag: FrFlag,
    },
    {
      code: 'nl-NL',
      name: 'Nederlands',
      flag: NlFlag,
    },
  ]

  // Current Locale Display
  const currentLocale = computed(() => {
    const selectedLocale =
      locales.find(loc => loc.code === locale.value) || locales[0]

    return selectedLocale
  })

  // Change Locale Function
  const changeLocale = (selectedLocale: string): void => {
    locale.value = selectedLocale

    // Format the seleted locale
    const companyLang = selectedLocale
      .split('-')[0]
      .toLowerCase() as CompanyLang
    Cookies.set(CookieName.COMPANY_LANG, companyLang)
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", _hoisted_3, [
        _createElementVNode("img", {
          src: currentLocale.value.flag,
          alt: "Current Language",
          class: "rounded-circle"
        }, null, 8, _hoisted_4),
        _createElementVNode("span", _hoisted_5, _toDisplayString(currentLocale.value.name), 1)
      ]),
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(locales, (loc) => {
          return _createElementVNode("li", {
            key: loc.code
          }, [
            _createElementVNode("button", {
              class: "dropdown-item d-flex align-items-center gap-2",
              onClick: ($event: any) => (changeLocale(loc.code))
            }, [
              _createElementVNode("img", {
                src: loc.flag,
                alt: "",
                class: "rounded-circle"
              }, null, 8, _hoisted_8),
              _createTextVNode(" " + _toDisplayString(loc.name), 1)
            ], 8, _hoisted_7)
          ])
        }), 64))
      ])
    ])
  ]))
}
}

})